import { useTranslation } from "react-i18next";
import "./JobDetails.scss";
import {
  AssessmentButton,
  AssessmentCheckboxRadio,
  showToast,
} from "ui-components";
import {
  convertDate,
  copyToClipboard,
  expandText,
  getTruncatedText,
  typesKeyPair,
} from "../../../../../../utils/Common/Constant";
import { useEffect, useRef, useState } from "react";
import CopyVector from "../../../../../../utils/Images/CopyVector";
import ShareIcon from "../../../../../../utils/Images/ShareIcon";
import { useNavigate } from "react-router-dom";
import i18n from "../../../../../../i18nConfig";
import WarningTriangle from "../../../../../../utils/Images/WarningTriangle";
import { updateCareerStatus } from "../../../../../../service/CvScanning/CvScanning";
const JobDetails = ({ jobData }: any) => {
  const { t } = useTranslation();
  const urlRef = useRef(null);
  const jobId = jobData?.jobId;
  const navigate = useNavigate();
  const currentLanguage = i18n.language;
  const [jobDetail, setJobDetail] = useState<any>({});
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const descriptionRef = useRef<any>(null);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setJobDetail(jobData);
    setIsVisible(jobData.isVisibleOnCareerPage);
  }, [jobData?.jobId]);

  const handleCheckboxFilterChange = async (isCurrentlyEnabled: boolean) => {
    const updatedStatus = !isCurrentlyEnabled;

    try {
      const res: any = await updateCareerStatus({
        jobId,
        isVisibleOnCareerPage: updatedStatus,
      });

      if (res?.status === 200) {
        showToast(res?.data?.customMessage, "success");
      }

      setIsVisible(updatedStatus);
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  return (
    <div className="jobDetails mb-5">
      <div className="joblinkWithCloseJob">
        <div className="careerEnableSwitch toggleSwitch">
          <span className="jobLink">{t("RESUME.SCANNING_PUBLIC_LINK")}</span>
          <AssessmentCheckboxRadio
            type="switch"
            checked={isVisible}
            label={t("CAREER.SHOW_ON_CAREER_PAGE")}
            onChange={() => handleCheckboxFilterChange(isVisible)}
          />
        </div>
        <div className="clipboardurl mt-3">
          <div className="URLCopyJoblink">
            {!jobDetail?.applyLink ? (
              <div className="completeProfileForJobLink">
                <WarningTriangle />
                <span>{t("GENERAL.COMPLETE_PROFILE_FOR_JOBLINK")}</span>
              </div>
            ) : (
              <div className="joblinkInput">
                <p ref={urlRef} title={t("RESUME.SCANNING_PUBLIC_LINK")}>
                  {jobDetail?.applyLink}
                </p>
                <div className="d-flex gap-2">
                  <div className="cursorPointer" title={t("RESUME.SHARE_JOB")}>
                    <AssessmentButton
                      className="lightBtn shareIcon"
                      onClick={() =>
                        navigate(`/${currentLanguage}/job/share-job/${jobId}`)
                      }
                    >
                      <ShareIcon />
                    </AssessmentButton>
                  </div>
                  <div
                    className="cursorPointer"
                    title={t("RESUME.SCANNING_PUBLIC_LINK")}
                  >
                    <AssessmentButton
                      className="lightBtn"
                      onClick={() =>
                        copyToClipboard(
                          urlRef,
                          jobDetail?.applyLink,
                          t("RESUME.JOB_LINK_COPY"),
                        )
                      }
                    >
                      <CopyVector />
                    </AssessmentButton>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="relevantProjectExperience decreaseGap">
        <div className="w-100">
          <div className="w-100 mb-4">
            <p>{t("RESUME.SCANNING_EXPERIENCE")}</p>
            <h5>{`${jobDetail?.minimumExperience ?? "3"} - ${jobDetail?.maximumExperience ?? "5"} ${t("CREATE_ASSESSMENT.EXP_YEARS")}`}</h5>
          </div>
          <div className="mb-4">
            <p>{t("GENERAL.ENGAGEMENT")}</p>
            <h5>{typesKeyPair[jobDetail?.jobType] ?? "-"}</h5>
          </div>
          <div>
            <p>{t("RESUME.BUDGET")}</p>
            <h5>
              {jobDetail?.minBudget && jobDetail?.maxBudget
                ? `${jobDetail.minBudget} - ${jobDetail.maxBudget} ${jobDetail.currencyName ? `(${jobDetail.currencyName})` : ""}`
                : "-"}
            </h5>
          </div>
        </div>
        <div className="w-100">
          <div className="w-100 mb-4">
            <p>{t("RESUME.SCANNING_OPEN_POSITIONS")}</p>
            <h5>{jobDetail?.noOfPositions ?? 0}</h5>
          </div>
          <div className="mb-4">
            <p>{t("RESUME.SCANNING_UPLOADED_CVS")}</p>
            <h5>{jobDetail?.uploadedCVs ?? "0"}</h5>
          </div>
          <div className="mb-4">
            <p>{t("RESUME.SHIFT_TIMING")}</p>
            <h5>
              {jobDetail?.shiftStartTime
                ? jobDetail?.shiftStartTime + " - " + jobDetail?.shiftEndTime
                : "-"}{" "}
              {jobDetail?.timezone && `(${jobDetail.timezone})`}
            </h5>
          </div>
        </div>
        <div className="w-100">
          <div className="w-100 mb-4">
            <p>{t("GENERAL.JOB_TYPE")}</p>
            <h5>{typesKeyPair[jobDetail?.engagementType] ?? "-"}</h5>
          </div>
          <div>
            <p>{t("GENERAL.CREATED")}</p>
            <h5>
              {jobDetail?.createdAt
                ? convertDate(jobDetail?.createdAt, false, true)
                : "-"}
            </h5>
          </div>
        </div>
      </div>
      <div className="horizontalLine"></div>
      <div className="keywords">
        <p>{t("RESUME.SCANNING_KEYWORDS")}</p>
        <div className="words">
          {jobDetail?.keywords?.length ? (
            jobDetail?.keywords?.split(",")?.map((item: any, ind: number) => {
              return (
                <div key={ind} className="wordsText">
                  <span>{item}</span>
                </div>
              );
            })
          ) : (
            <span className="naText">NA</span>
          )}
        </div>
      </div>
      <div className="horizontalLine"></div>
      <div className="location">
        <p>{t("RESUME.SCANNING_LOCATION")}</p>
        <div className="row">
          {jobDetail?.jobLocations?.length ? (
            jobDetail?.jobLocations?.map((item: any, index: any) => (
              <div className="col-md-4 col-sm-6 mb-3" key={index}>
                <div className="locationCard">
                  <div className="addedLocationTop">
                    <span>{t("RESUME.SCANNING_LOCATION")}</span>
                  </div>
                  <div className="addressText">
                    <span>{`${item?.addressLine1 ?? ""} ${item?.addressLine2 ?? ""}`}</span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-md-4 col-sm-6 mb-3">-</div>
          )}
        </div>
      </div>
      <div className="horizontalLine"></div>
      <div className="additionalInfo">
        <p>{t("RESUME.SCANNING_ADDITIONAL_NOTES")}</p>
        <div
          className="additionalInfoText"
          ref={descriptionRef}
          dangerouslySetInnerHTML={{
            __html: jobDetail?.additiionalNotes ?? "-",
          }}
        />
      </div>
      <div className="horizontalLine"></div>
      <div className="description">
        <p>{t("RESUME.SCANNING_DESCRIPTION")}</p>
        <div
          ref={descriptionRef}
          dangerouslySetInnerHTML={{
            __html: isExpanded
              ? jobDetail?.description
              : getTruncatedText(jobDetail?.description, 25),
          }}
        />
        {jobDetail?.description?.length > 0 && (
          <span
            onClick={() =>
              expandText(descriptionRef, setIsExpanded, isExpanded)
            }
            className="readMoreBtn"
          >
            {isExpanded ? t("GENERAL.READ_LESS") : t("GENERAL.READ_MORE")}
          </span>
        )}
      </div>
    </div>
  );
};

export default JobDetails;
